module.exports = __webpack_public_path__ + "static/media/Presence.c9f61ccb.svg";